function format(number) {
  number += "";
  number = new Array(4 - number.length % 3).join("U") + number;
  return number.replace(/([0-9U]{3})/g, "$1 ").replace(/U/g, "");
}

export default format